export default{
    server: 'http://localhost/dracomini/'
}